import { render, staticRenderFns } from "./ReceptionList.vue?vue&type=template&id=7ba4c7a5&"
import script from "./ReceptionList.vue?vue&type=script&lang=js&"
export * from "./ReceptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports